<div class="header">
  <div class="object-name">
    {{ attributes.name }}
  </div>
  <div class="sub-header">
    {{ attributes.segmentType }}
  </div>
</div>
<div class="info-container">
  @if (attributes.segmentStart) {
    <div class="info">
      <p class="field-title">Segment Start</p>
      {{ attributes.segmentStart }}
      @if (attributes.startCoordinates) {
        <span class="coordinates"
          >({{ attributes.startCoordinates }})</span
          >
        }
      </div>
    }
    @if (attributes.segmentEnd) {
      <div class="info">
        <p class="field-title">Segment End</p>
        {{ attributes.segmentEnd }}
        @if (attributes.endCoordinates) {
          <span class="coordinates"
            >({{ attributes.endCoordinates }})</span
            >
          }
        </div>
      }
      @if (attributes.segmentDistance) {
        <div class="info">
          <p class="field-title">Segment Distance</p>
          {{ attributes.segmentDistance }}
        </div>
      }
      @if (attributes.inboundBearing) {
        <div class="info">
          <p class="field-title">Inbound Bearing</p>
          {{ attributes.inboundBearing }}
        </div>
      }
      @if (attributes.outboundBearing) {
        <div class="info">
          <p class="field-title">Outbound Bearing</p>
          {{ attributes.outboundBearing }}
        </div>
      }
      @if (attributes.minEnrouteAlt) {
        <div class="info">
          <p class="field-title">Minimum Enroute Altitude</p>
          {{ attributes.minEnrouteAlt }}
        </div>
      }
      @if (attributes.totalMileage) {
        <div class="info">
          <p class="field-title">Total Mileage</p>
          {{ attributes.totalMileage }}
        </div>
      }
    </div>
